import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "447346209593";
const WHATSAPP_MSG = "Hi! I'd like to get a quote for my move.";

const WhatsAppButton = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 lg:bottom-6 right-4 z-50 w-14 h-14 bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform group rounded-full"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-btn"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="absolute right-full mr-3 bg-white text-[#0F172A] text-sm font-semibold px-3 py-2 shadow-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us
      </span>
    </a>
  );
};

export default WhatsAppButton;
